/**
 * Tango Exchange optional modules. The single switch for showing them to
 * partners (pilot decision D4, 3 Nov 2026: Profile, Assets and Data rooms
 * only at launch). Set a module to true to bring it back; its page files,
 * routes and database rules are kept.
 *
 * Screens only: partner database rules for these tables are unchanged.
 */
export type ExchangeModule = "deals" | "training" | "mdf";

export const EXCHANGE_MODULES: Record<ExchangeModule, boolean> = {
  deals: false,
  training: false,
  mdf: false,
};

export function isModuleEnabled(
  module: ExchangeModule,
  modules: Record<ExchangeModule, boolean> = EXCHANGE_MODULES,
): boolean {
  return modules[module] === true;
}

/** Drop nav items whose module is switched off; items without a module stay. */
export function filterNavByModules<T extends { module?: ExchangeModule }>(
  items: T[],
  modules: Record<ExchangeModule, boolean> = EXCHANGE_MODULES,
): T[] {
  return items.filter((i) => !i.module || isModuleEnabled(i.module, modules));
}

/** Where a module route should go: null renders the page, otherwise redirect. */
export function moduleRedirect(
  module: ExchangeModule,
  modules: Record<ExchangeModule, boolean> = EXCHANGE_MODULES,
): string | null {
  return isModuleEnabled(module, modules) ? null : "/exchange";
}
